/**
 * How the console writes a moment: Indian order, in IST, whatever the operator's laptop says.
 *
 * `toLocaleString()` with no arguments takes the browser's locale and zone, so the same audit row
 * read "10/30/2026, 12:44:21 AM" on one desk and "30/10/2026, 00:44:21" on another — and on a
 * laptop set to another zone, a different hour. Every timestamp the console shows goes through
 * here so two operators reading one row read the same thing.
 */
const IST = 'Asia/Kolkata';

/** "30 Oct 2026, 12:44 am" */
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-IN', {
    timeZone: IST,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** "30 Oct 2026" */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-IN', { timeZone: IST, day: 'numeric', month: 'short', year: 'numeric' });
}

/** "2026-11" — the IST month a moment falls in, which is how a TDS deposit is due (by the 7th of the next). */
export function istMonth(iso: string): string {
  return new Date(iso).toLocaleDateString('en-CA', { timeZone: IST, year: 'numeric', month: '2-digit' });
}
